// Gift message character counter
function initGiftMessageCounter() {
  const giftMessageTextareas = document.querySelectorAll('[data-cart-note]');
  const maxLength = 300;

  giftMessageTextareas.forEach(textarea => {
    // Set maxlength attribute
    textarea.setAttribute('maxlength', maxLength);
    
    // Check if counter already exists
    const existingCounter = textarea.parentNode.querySelector('.gift-message-counter');
    if (existingCounter) {
      // If counter exists, just update it
      updateCounter(textarea, existingCounter, maxLength);
      return;
    }
    
    // Create counter element
    const counterContainer = document.createElement('div');
    counterContainer.className = 'gift-message-counter';
    
    // Insert counter after textarea
    textarea.parentNode.insertBefore(counterContainer, textarea.nextSibling);
    
    // Add event listeners
    textarea.addEventListener('input', () => updateCounter(textarea, counterContainer, maxLength));
    textarea.addEventListener('focus', () => updateCounter(textarea, counterContainer, maxLength));
    
    // Initialize counter
    updateCounter(textarea, counterContainer, maxLength);
  });
}

// Separate update counter function
function updateCounter(textarea, counterElement, maxLength) {
  const remaining = maxLength - textarea.value.length;
  let translatedText = '{{ count }} characters remaining';
  
  // Try to get translation if available
  if (window.PXUTheme && window.PXUTheme.translation && window.PXUTheme.translation.note_characters_remaining) {
    translatedText = window.PXUTheme.translation.note_characters_remaining;
  }
  
  counterElement.textContent = translatedText.replace('{{ count }}', remaining);
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  initGiftMessageCounter();
}); 